
import React from 'react'
import { createRoot } from 'react-dom/client'
import '@/lib/i18n';
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'
import { initPreloadErrorReload } from './lib/preload-error-reload'

// Initialize Sentry before rendering the app
initSentry();
// Full id, not truncated: this line is for whoever is reading logs, and a full
// SHA pastes straight into `git show`. Placed after initSentry() so it is
// captured as an early breadcrumb on any later event.
console.log(`🏷️ build ${__BUILD_ID__} (${import.meta.env.MODE})`);
// Self-heal a stale tab that hits a 404 on a deleted route chunk post-deploy
initPreloadErrorReload();
// Dev-only: log a [dialog-overflow] error when a dialog scrolls sideways or
// clips an edge (DESIGN.md §22). Tree-shaken out of production builds.
if (import.meta.env.DEV) void import('./lib/dev/dialog-overflow-guard').then((m) => m.installDialogOverflowGuard());

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
